import './App.css';
import { Route , Routes } from 'react-router-dom';
import Home from './pages/Home/Home';
import TransactionDashboard from './pages/Transactiondashboard/TransactionDashboard';
import Dashboard from './pages/Dashboard/Dashboard';
import OrderDashboard from './pages/OrdersDashboard/OrderDashboard';
import CustomerDashboard from './pages/CustomerDashboard/CustomerDashboard';
import ProductDashboard from './pages/ProductsDashboard/ProductDashboard';
import PaymentSection from './pages/Home/PaymentSection';
import CustomerOrderHistory from './pages/CustomerDashboard/CustomerOrderHistory';
import LogoutDashboard from './pages/Others/LogoutDashboard';
import ErrorDashboard from './pages/Others/ErrorDashboard';
import DeliveryPersonDasboard from './pages/DeliveryPerson/DeliveryPersonDasboard';
import BulkOrders from './pages/BulkOrderDashboard/BulkOrders';
import ManageAreas from './pages/manageAreas/ManageAreas';
import PrivacyPolicy from './pages/Policies/Privacypolicy';
import TermsConditions from './pages/Policies/TermsConditions';
import DeleteAccount from './pages/Policies/DeleteAccount';
function App() {
  return (
    <Routes>
       <Route path='/' element={<Home/>}></Route>
       <Route path='/TransactionDashboard' element={<TransactionDashboard/>}> </Route>
       <Route path='/Dashboard' element={<Dashboard/>}> </Route>
       <Route path='/OrderDashboard' element={<OrderDashboard/>}> </Route>
       <Route path='/Bulkorders' element={<BulkOrders/>}> </Route>
       <Route path='/CustomerDashboard' element={<CustomerDashboard/>}> </Route>
       <Route path='/DeliveryPerson' element={<DeliveryPersonDasboard/>}> </Route>
       <Route path='/ProductDashboard' element={<ProductDashboard/>}> </Route>
       <Route path='/PaymentSection' element={<PaymentSection/>}> </Route>
       <Route path='/OrderHistory' element={<CustomerOrderHistory/>}> </Route>
       <Route path='/logoutDashboard' element={<LogoutDashboard/>}> </Route>
       <Route path='/ErrorDashboard' element={<ErrorDashboard/>}> </Route>
       <Route path='/areas' element={<ManageAreas/>}> </Route>
       <Route path='/PrivacyPolicy' element={<PrivacyPolicy/>}> </Route>
       <Route path='/TermsConditions' element={<TermsConditions/>}> </Route>
       <Route path='/DeleteAccount' element={<DeleteAccount/>}> </Route>
    </Routes>
  );
}

export default App;
